"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicService = void 0;
const Helper_1 = require("../common/Helper");
class PublicService {
    constructor(configUserProvider) {
        this.config = configUserProvider.getConfig();
    }
    /**
     * Each and every proccesses starts with requestId, it is an entry point to login or register. For getting the requestId, call **getRequestId()**.
     * @example
     * ```js
     * // To get requestId using default configured settings, run the function without parameter
     * cidaasPublicService.getRequestId().then(function (response) {
     *   // the response will give you request id.
     * }).catch(function(ex) {
     *   // your failure code here
     * });
     *
     * // To get requestId using custom settings, run the function with custom setting(s) inside option parameter. Example below will only override client_id & redirect_uri
     * const option: GetRequestIdRequest = {
     *   'client_id': 'your client id',
     *   'redirect_uri': 'your redirect url',
     * }
     * cidaasPublicService.getRequestId(option).then(function (response) {
     *   // the response will give you request id.
     * }).catch(function(ex) {
     *   // your failure code here
     * });
     * ```
     */
    getRequestId(option) {
        var _a, _b, _c, _d, _e;
        const ui_locales = this.config.ui_locales;
        const payload = Object.assign({ 'client_id': (_a = option === null || option === void 0 ? void 0 : option.client_id) !== null && _a !== void 0 ? _a : this.config.client_id, 'redirect_uri': (_b = option === null || option === void 0 ? void 0 : option.redirect_uri) !== null && _b !== void 0 ? _b : this.config.redirect_uri, 'response_type': (_c = option === null || option === void 0 ? void 0 : option.response_type) !== null && _c !== void 0 ? _c : (this.config.response_type || 'token'), 'response_mode': (_d = option === null || option === void 0 ? void 0 : option.response_mode) !== null && _d !== void 0 ? _d : (this.config.response_mode || 'fragment'), 'scope': (_e = option === null || option === void 0 ? void 0 : option.scope) !== null && _e !== void 0 ? _e : this.config.scope, 'nonce': new Date().getTime().toString() }, (ui_locales && { ui_locales } || {}));
        const serviceURL = this.config.authority + '/authz-srv/authrequest/authz/generate';
        return Helper_1.Helper.createHttpPromise(payload, serviceURL, false, "POST");
    }
    /**
     * To get the tenant basic information, call **getTenantInfo()**. This will return the basic tenant details such as tenant name and allowed login with types (Email, Mobile, Username).
     * @example
     * ```js
     * cidaasPublicService.getTenantInfo().then(function (response) {
     *   // the response will give you tenant details
     * }).catch(function(ex) {
     *   // your failure code here
     * });
     * ```
     */
    getTenantInfo() {
        const _serviceURL = this.config.authority + "/public-srv/tenantinfo/basic";
        return Helper_1.Helper.createHttpPromise(undefined, _serviceURL, false, "GET");
    }
    /**
     * To get the client basic information, call **getClientInfo()**. This will return the basic client details such as client name and its details.
     * Please refer to the api document https://docs.cidaas.com/docs/cidaas-iam/dc8a6cfb28abb-public-page-information for more details.
     * @example
     * ```js
     * cidaasPublicService.getClientInfo({
     *   requestId: 'your requestId',
     * }).then(function (resp) {
     *   // the response will give you client info.
     * }).catch(function(ex) {
     *   // your failure code here
     * });
     * ```
     */
    getClientInfo(options) {
        const _serviceURL = this.config.authority + "/public-srv/public/" + options.requestId;
        return Helper_1.Helper.createHttpPromise(undefined, _serviceURL, false, "GET");
    }
}
exports.PublicService = PublicService;
